import { queryOptions, useQuery } from '@tanstack/react-query';
import { TruckRecordingMipService } from '../generated';
import { blobToDataURL } from '../common';
import { ApiError } from '../../components/ApiLoadingGuard/ApiLoadingGuard';

export interface TruckRecordingMipImageOptionsProps {
  jobsiteId?: string;
  mipReportId?: string;
}

export const truckRecordingMipImageQueryKeys = {
  base: () => ['truckRecordingMipImage'] as const,
  one: ({ jobsiteId, mipReportId }: TruckRecordingMipImageOptionsProps) =>
    [...truckRecordingMipImageQueryKeys.base(), jobsiteId, mipReportId] as const,
};

export function truckRecordingMipImageOptions({ jobsiteId, mipReportId }: TruckRecordingMipImageOptionsProps) {
  return queryOptions<string, ApiError>({
    queryKey: truckRecordingMipImageQueryKeys.one({ jobsiteId, mipReportId }),
    queryFn: async () => {
      if (!jobsiteId || !mipReportId) {
        throw new Error('jobsiteId and mipReportId are required');
      }

      const response = await TruckRecordingMipService.truckRecordingMipControllerGetRecordingImage({
        path: {
          jobsiteId,
          mipReportId,
        },
      });

      if (response.data !== undefined) {
        return await blobToDataURL(response.data as Blob);
      }

      throw (response as any).error || new Error(response.response?.statusText || 'Unknown error');
    },
    enabled: !!jobsiteId && !!mipReportId,
  });
}

export function useTruckRecordingMipImage(props: TruckRecordingMipImageOptionsProps) {
  return useQuery(truckRecordingMipImageOptions(props));
}
